<template>
  <transition name="modal-fade">
    <div class="modal-overlay" v-if="isVisible">
      <div class="modal-content">
        <div class="modal-header">
          <div class="icon-gears">
            <img
              :src="iconManutencao"
              alt="Ícone de manutenção"
              width="32"
              height="32"
            />
          </div>
          <h2>Em manutenção</h2>
        </div>

        <div class="modal-body">
          <p>
            Estamos atualizando nosso sistema para melhor atendê-lo, mas seu
            cuidado não para.
          </p>

          <p class="mt-24">
            Para acessar seus exames agora de forma manual, fale conosco:
          </p>

          <div class="whatsapp-block">
            <p><strong>WhatsApp: 0800 048 3500</strong></p>
            <p>No menu, escolha: <strong>Opção 2 > Opção 8.</strong></p>
          </div>

          <div class="thanks-block">
            <p>Nossa equipe está pronta para enviar o que você precisa.</p>
            <p class="text-green">
              Obrigado por confiar na Unimed Grande Florianópolis!
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <a
            href="https://web.whatsapp.com/send/?phone=5508000483500&text&type=phone_number&app_absent=0"
            target="_blank"
            class="btn-action"
          >
            Solicitar exames pelo WhatsApp
          </a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import imageManutencao from "../assets/imagens/icon-manufacturing.svg";
import { obterJsonManutencao } from "../http/configuracoes";

export default {
  name: "ModalExamesManutencao",
  data() {
    return {
      isVisible: false,
      iconManutencao: imageManutencao,
    };
  },
  async mounted() {
    await this.validarPeriodoManutencao();
  },
  methods: {
    async validarPeriodoManutencao() {
      try {
        const response = await obterJsonManutencao();

        if (response.ok) {
          const config = await response.json();
          const agora = new Date();

          const dataInicio = new Date(config.dataInicioBloqueio);
          const dataFim = new Date(config.dataFimBloqueio);

          this.isVisible = agora >= dataInicio && agora <= dataFim;
        }
      } catch (error) {
        console.error("Erro ao validar período de manutenção:", error);
        this.isVisible = false;
      } finally {
        this.$emit("status-manutencao", this.isVisible);
      }
    },
    fecharModal() {
      this.isVisible = false;
      this.$emit("status-manutencao", false);
    },
  },
};
</script>

<style>
body {
  font-family: "Trebuchet MS";
}
</style>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background-color: #ffffff;
  width: 580px;
  border-radius: 4px;
  position: relative;
  border: 1px solid #dcdcdc;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  color: #333;
  padding: 0;
}

.modal-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 40px 10px 40px;
  border-bottom: none;
}

.icon-gears {
  margin-bottom: 20px;
}

h2 {
  font-size: 22px;
  font-weight: 500;
  margin: 0;
  color: #222;
  text-align: center;
}

.modal-body {
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  text-align: left;
  padding: 16px 16px;
}

.modal-body p {
  margin: 0;
}

.mt-24 {
  margin-top: 24px !important;
}

.whatsapp-block {
  margin-top: 24px;
  margin-bottom: 24px;
}

.whatsapp-block p {
  margin-bottom: 4px;
}

.thanks-block p {
  margin-bottom: 4px;
}

.text-green {
  color: #00844f;
}

.modal-footer {
  text-align: right;
  border-top: 1px solid #eaeaea;
  padding: 20px 40px;
}

.btn-action {
  display: inline-block;
  background-color: #00844f;
  color: #ffffff;
  text-decoration: none;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.btn-action:hover {
  background-color: #006b40;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
